import React from "react";
import { Tooltip, Icon, Link } from "@shopify/polaris";
import { InfoIcon } from "@shopify/polaris-icons";

export function HelpIconLink({ url }: { readonly url: string }): React.ReactElement {
  // Tooltip AKA hovertext aka hover-over text aka pop-up text aka popover text
  return (
    <Link monochrome url={url}>
      <Tooltip content="Learn more">
        <Icon source={InfoIcon} tone="subdued" />
      </Tooltip>
    </Link>
  );
}
